module.exports = __webpack_public_path__ + "static/hitec-067e40f9f12695fff88c6eacdfa1a42a.png";